import React, { useEffect, useState, useRef } from 'react';
import { FilterOff } from '../../../modules/Dispatch/icons';
import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import GRID_CONSTANTS from '../../GridConstants';
import Tooltip from '../../../common/StyledToolTip';

const styles = (theme) => ({
  container: {
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    float: 'left',
    color: theme.iconColor,
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  }
});

const ClearAllFilterButton = ({ classes, theme, gridApi }) => {
  const [activeFilterCount, setActiveFilterCount] = useState(0);
  const isClearFilterClickedRef = useRef(false);

  useEffect(() => {
    addFilterChangedListener();
    return () => {
      removeFilterChangedListener();
    };
  }, [gridApi]);

  const addFilterChangedListener = () => {
    if (gridApi?.addEventListener) {
      gridApi.addEventListener(
        GRID_CONSTANTS.GRID_EVENT_TYPES.FILTER_CHANGED,
        updateActiveFilterCount
      );
    }
  };

  const removeFilterChangedListener = () => {
    if (gridApi?.removeEventListener) {
      gridApi.removeEventListener(
        GRID_CONSTANTS.GRID_EVENT_TYPES.FILTER_CHANGED,
        updateActiveFilterCount
      );
    }
  };

  const updateActiveFilterCount = () => {
    const filterModel = gridApi?.getFilterModel();
    if (!filterModel) return;
    const count = Object.keys(filterModel).filter((key) => filterModel[key]?.length).length;
    setActiveFilterCount(count);

    if (count === 0 && isClearFilterClickedRef.current) {
      // User clicked on clear all filters and the filters are cleared
      gridApi.onFilterChanged();
      isClearFilterClickedRef.current = false;
    }
  };

  const clearAllFilters = () => {
    if (!gridApi) return;
    isClearFilterClickedRef.current = true;
    gridApi.setFilterModel(null);
  };

  if (activeFilterCount === 0) return null;

  const tooltipString = `Clear ${activeFilterCount > 1 ? 'all' : ''} ${activeFilterCount} filter${
    activeFilterCount > 1 ? 's' : ''
  }`;

  return (
    <div className={classes.container}>
      <Tooltip title={tooltipString}>
        <div onClick={clearAllFilters}>
          <FilterOff color={theme.iconColor} />
        </div>
      </Tooltip>
    </div>
  );
};

export default compose(withTheme(), withStyles(styles))(ClearAllFilterButton);
